import type { Process } from "@certa/studio-core/src/types/process.types";
import { filePathsRegex } from "@certa/studio/src/constants/regex.constants";
import { forwardParseECA } from "./ecaForwardParser";
import {
  forwardParseProcessMetadataSync,
  forwardParseSwimlanes
} from "./forwardParser";
import type { ProcessRawAppJSON } from "@certa/queries/schemas/studio/appProcessJSON.schema";
/**
 *
 * @param processId
 * @returns
 */
export const forwardParseAppMetaJSONSync = ({
  metaJSON,
  shouldIgnoreInvalidReferences
}: {
  metaJSON: Process;
  shouldIgnoreInvalidReferences?: boolean;
}) => {
  try {
    const { process } = metaJSON;

    const { stepgroupsAppJSON = [], stepGroupFilePaths = [] } =
      forwardParseSwimlanes({
        swimlaneUUIDs: process.swimlaneSequence,
        metaJSON,
        shouldIgnoreInvalidReferences
      });

    const filteredFilePaths = Array.from(
      stepGroupFilePaths.filter(path => path.match(filePathsRegex))
    );

    let ecaData = {};
    const eventRules = Object.values(metaJSON.eventRules || {});
    const stateRules = Object.values(metaJSON.stateRules || {});

    if (eventRules?.length || stateRules?.length) {
      ecaData = forwardParseECA(metaJSON, false);
    }

    const processMetadata = forwardParseProcessMetadataSync({
      metaJSON,
      shouldIgnoreInvalidReferences
    });

    const processJSON: ProcessRawAppJSON = {
      ...processMetadata,
      stepgroups: stepgroupsAppJSON,
      file_paths: filteredFilePaths.length ? filteredFilePaths : undefined,
      ...ecaData,
      __studio_id: Number(process.id),
      __studio_created_at: process.__createdAt,
      __studio_modified_at: process.__modifiedAt,
      __studio_branch_timestamp: process.__branchTimestamp,
      __studio_save_id: process.__saveId,
      __studio_last_migration: process.__lastMigration
    };

    return processJSON;
  } catch (e: unknown) {
    throw e;
  }
};
